import React, { useState, useEffect, useRef, useContext } from 'react'
import { logoutUser, updateEmail, updatePassword } from '../../api/auth';
import { ButtonGrey, ButtonRed, ToogleButton } from '../../components/common/Button';
import Header from '../../components/common/Header';
import { PlainInput, InputWithButton } from '../../components/common/Input';
import Checkbox from '../../components/Settings/Checkbox';
import SettingsTabBar from '../../components/Settings/SettingsTabBar'
import SettingThemeChanger from '../../components/Settings/SettingThemeChanger';
import { DarkModeContext } from '../../global/Theme'
import './settings.sass'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { SuccessValidator, ErrorValidator, GrayValidator } from '../../components/common/Validator'


import PWA from '../../utils/PWA'

export default function Settings() {

    const [isMobile, setIsMobile] = useState(false)
    const accountRef = useRef(0);
    const notificationRef = useRef(0)
    const [deleteConf, setDeleteConf] = useState(false)
    const { isDark } = useContext(DarkModeContext)
    const history = useHistory()
    const [loggingOut, setLoggingOut] = useState(false)
    const dispatch = useDispatch()

    const [bodyWidth, setBodyWidth] = useState(document.body.clientWidth);
    const [bodyHeight, setBodyHeight] = useState(document.body.clientHeight);

    const [supportsPWA, setSupportsPWA] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);


    useEffect(() => {
        const handler = e => {
            e.preventDefault();
            setSupportsPWA(true);
            setPromptInstall(e);
        };

        window.addEventListener("beforeinstallprompt", handler);

        return () => window.removeEventListener("transitionend", handler);
    }, []);

    const onClick = evt => {
        evt.preventDefault();
        if (!promptInstall) {
            return;
        }
        promptInstall.prompt();
    };



    const toggleDeletion = () => {
        setDeleteConf(!deleteConf)
    }

    const updateTab = (e, setIsActive) => {
        if (e == 0) {
            try {
                accountRef.current.style.display = "grid";
                accountRef.current.style.maxWidth = "100%"
                accountRef.current.style.flex = "100%"
                accountRef.current.style.paddingRight = "0px"
                setIsActive(0);
                notificationRef.current.style.display = "none";
            } catch (e) { }
        } else if (e == 1) {
            try {
                notificationRef.current.style.display = "grid";
                notificationRef.current.style.maxWidth = "100%"
                notificationRef.current.style.flex = "100%"
                notificationRef.current.style.paddingRight = "0px"
                setIsActive(1);
                accountRef.current.style.display = "none";
            } catch (e) { }
        }
    }

    const handleLogout = async () => {
        setLoggingOut(true)
        await logoutUser();
        dispatch({
            type: 'UPDATE_NAV', payload: {
                notification: false,
                home: true,
                search: false,
                post: false,
                chat: false,
                profile: false
            }
        })
        dispatch({
            type: 'TOOGLE_LOGGEDIN'
        })
        history.push({
            pathname: '/login'
        })
    }

    // here we have states for seettings 
    // for push notification

    const settingState = useSelector(state => state.settingState);

    const [pushNewComments, setPushNewComments] = useState(settingState.pushNewComments)
    const [pushNewLikes, setPushNewLikes] = useState(settingState.pushNewLikes)
    const [pushNewSubscribers, setPushNewSubscribers] = useState(settingState.pushNewSubscribers)
    const [pushNewTip, setPushNewTip] = useState(settingState.pushNewTip)
    const [pushNewMessage, setPushNewMessage] = useState(settingState.setPushNewMessage)
    const [pushNotifications, setPushNotifications] = useState(settingState.pushNotifications)
    // for email notification
    const [emailNewComments, setEmailNewComments] = useState(settingState.emailNewComments)
    const [emailNewLikes, setEmailNewLikes] = useState(settingState.emailNewLikes)
    const [emailNewSubscribers, setEmailNewSubscribers] = useState(settingState.emailNewSubscribers)
    const [emailNewTip, setEmailNewTip] = useState(settingState.emailNewTip)
    const [emailNewMessage, setEmailNewMessage] = useState(settingState.setEmailNewMessage)
    const [emailNotifications, setEmaiNotifications] = useState(settingState.emailNotifications)

    // validators
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("")
    const [email, setEmail] = useState("");
    const [emailPassword, setEmailPassword] = useState("");


    const [isPasswordValid, setIsPasswordValid] = useState(-1);
    const [passwordError, setPasswordError] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);

    const [isEmailValid, setIsEmailValid] = useState(-1);
    const [emailError, setEmailError] = useState(false);

    const [updateEmailBtn, setUpdateEmailBtn] = useState("SAVE");
    const [updatePasswordBtn, setUpdatePasswordBtn] = useState("SAVE");

    const [passwordChangeFailed, setPasswordChangeFailed] = useState(null);
    const [emailChangeFailed, setEmailChangeFailed] = useState(null);



    useEffect(() => {
        const newSettingState = {
            pushNewComments: pushNewComments,
            pushNewLikes: pushNewLikes,
            pushNewSubscribers: pushNewSubscribers,
            pushNewTip: pushNewTip,
            pushNewMessage: pushNewMessage,
            pushNotifications: pushNotifications,
            emailNewComments: emailNewComments,
            emailNewLikes: emailNewLikes,
            emailNewSubscribers: emailNewSubscribers,
            emailNewTip: emailNewTip,
            emailNewMessage: emailNewMessage,
            emailNotifications: emailNotifications,
        }

        dispatch({
            type: "PUSH_SETTINGS",
            payload: newSettingState,
        })

    }, [pushNewComments, pushNewLikes, pushNewSubscribers, pushNewTip, pushNewMessage, pushNotifications, emailNewComments, emailNewLikes, emailNewSubscribers, emailNewTip, emailNewMessage, emailNotifications])




    useEffect(() => {
        validatePassword(password)
    }, [password])

    useEffect(() => {
        validateConfirmPassword(confirmPassword)
    }, [confirmPassword])

    useEffect(() => {
        validateEmail(email);
    }, [email])



    const validatePassword = (password) => {
        var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        if (reg.test(password) == false) {
            setIsPasswordValid(0);
            setPasswordError(true);
            return false;
        }
        setIsPasswordValid(1);
        setPasswordError(false);
        return true;
    }

    const validateConfirmPassword = (confirmPassword) => {
        if (confirmPassword !== password) {
            setConfirmPasswordError(true);
            return false;
        }
        setConfirmPasswordError(false);
        return true;
    }


    const validateEmail = (emailField) => {
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (reg.test(emailField) == false) {
            setIsEmailValid(0)
            setEmailError(true);
            return false;
        }
        setIsEmailValid(1)
        setEmailError(false);
        return true;
    }

    const handleUpdateEmail = async () => {
        setUpdateEmailBtn('SAVING..')
        try {
            await updateEmail(email);
            setUpdateEmailBtn("SAVED");
        } catch (e) {
            setUpdateEmailBtn("SAVE");
        }
    }

    const handleUpdatePassword = async () => {
        setUpdatePasswordBtn('SAVING..')
        try {
            await updatePassword(password);
            setUpdatePasswordBtn("SAVED");
        } catch (e) {
            setUpdatePasswordBtn("SAVE");
            if (e.code == 'auth/requires-recent-login')
                setPasswordChangeFailed('Re-login and try again');
            else
                setPasswordChangeFailed('Re-login and try again');
        }
    }


  const updateView = (v) => {
        if (v <= 586) {
            document.getElementById('mainWrapper').classList.remove('padding')
            document.getElementById('mainWrapper').classList.add('zero-p')
            document.getElementById('mobileNav').style.display = "none"
			document.getElementById('mainWrapper').style.cssText = "padding: 70px 0 0 0 !important"	


        } else {
            document.getElementById('mainWrapper').classList.add('padding')
            document.getElementById('mainWrapper').classList.remove('zero-p')
            document.getElementById('mobileNav').style.display = "none"
        }
        // if (v <= 830) {
        //     try {
        //       //  notificationRef.current.style.display = "none";
        //         accountRef.current.style.display = "block";

        //         accountRef.current.style.maxWidth = "100%"
        //         accountRef.current.style.flex = "100%"
        //         accountRef.current.style.paddingRight = "0px"

        //     } catch (e) { }
        // }
        // if(v >= 580){
        //     // accountRef.current.style.display = "grid";
        //     // notificationRef.current.style.display = "grid";
        // }
        // else {
        //     try {
        //         accountRef.current.style.display = "grid";
        //         notificationRef.current.style.display = "grid";

        //     } catch (e) {

        //     }
        // }
    }


    

    useEffect(() => {
        updateView(window.innerWidth)

        window.addEventListener('resize', v => {
            setBodyHeight(document.body.clientHeight);
            setBodyWidth(document.body.clientWidth);
            updateView(v.target.innerWidth)
        })

        return () => {
			document.getElementById('mainWrapper').style.cssText = "padding: 70px 10px 70px 10px !important"	
        }
    }, [])




    return (
        <div className='settings-wrapper'>
            <div className="settings-mobile-tab">
                <SettingsTabBar title="Settings" onUpdate={updateTab} text="Account settings" img="setting" text2="Notification settings" img2="notifications" />
            </div>
            <div className='settings-row'>
                <div ref={accountRef} className='settingLCol'>
                    <div className="setting-left-col-header-desktop">
                        {(!isMobile) ? <Header img='setting.svg' text="Account settings" /> : ''}
                    </div>
                    <div className="settings-col-left-content">
                        <p className='setting-text-header'>Dark Mode Options</p>
                        <SettingThemeChanger />
                        <p className='setting-text-header'>Install App Status</p>
                        <p className='setting-text-normal'>Available on Android, iPhone, Windows and Mac.</p>
                        <p className='setting-text-small'>No download needed! LOVR use latest technologies.</p>

                        <div className='app-status-row'>
                            {supportsPWA && <div onClick={onClick} className='app-status-install'>
                                <p>Install App</p>
                            </div>}
                            {supportsPWA && <div className={`${isDark ? 'app-status-dark' : 'app-status-light'}`}>
                                <p>Status:  <span> Not installed!</span></p>
                            </div>}

                        </div>

                        {!promptInstall &&
                            <div className='app-status-row'>
                                <div className={`${isDark ? 'app-status-dark' : 'app-status-light'}`}>
                                    <p>Status:  <span> Already installed.</span></p>
                                </div>
                            </div>
                        }


                        <p className='setting-text-header'>Change Password</p>

                        <PlainInput
                            handleOnChange={e => setPassword(e.target.value)}
                            isError={password.length > 0 && passwordError}
                            type='password'
                            placeholder='New Password' />
                        {isPasswordValid != -1 && password.length > 0 ?
                            isPasswordValid == 0 ?
                                <ErrorValidator text="Password is weak" /> :
                                <SuccessValidator text="Password is strong" /> :
                            <GrayValidator text="Password meter" />}

                        <p className='setting-text-normal'>The password must contain at least 8 characters, at least 1 capital letter and at least 1 digit.</p>
                        <div className='conf-password-wrapper'>
                            <InputWithButton handleOnChange={e => setConfirmPassword(e.target.value)}
                                type='password'
                                onButtonClick={handleUpdatePassword}
                                btnText={updatePasswordBtn}
                                btnActive={!confirmPasswordError && !passwordError && confirmPassword.length > 0}
                                placeholder='Confirm Password' />
                        </div>
                        {confirmPasswordError && confirmPassword.length > 0 && <ErrorValidator text="Password doesn't match" />}
                        {passwordChangeFailed != null && <div style={{ margin: '10px 0px' }}>
                            <ErrorValidator text={passwordChangeFailed} /> </div>}

                        <p style={{ marginBottom: '0px', marginTop: '10px' }} className='setting-text-header'>Change Email</p>
                        <div className='conf-password-wrapper'>
                            <PlainInput
                                isError={email.length > 0 && emailError}
                                type='email'
                                handleOnChange={e => setEmail(e.target.value)}
                                placeholder='New Email Address' />
                        </div>

                        {isEmailValid != -1 && email.length > 0 ?
                            isEmailValid == 0 ? <ErrorValidator text="Invalid Email" /> : null : null
                        }

                        {emailChangeFailed != null && <div style={{ margin: '10px 0px' }}>
                            <ErrorValidator text={emailChangeFailed} /> </div>}

                        <div className='conf-password-wrapper'>
                            <InputWithButton
                                type='password'
                                handleOnChange={e => setEmailPassword(e.target.value)}
                                btnActive={!emailError && emailPassword.length >= 8}
                                btnText={updateEmailBtn}
                                onButtonClick={handleUpdateEmail}
                                placeholder='Confirm Password' />

                        </div>
                        {/* <p style={{ marginTop: '0px' }} className='setting-text-header'>Account Deletion</p>
                    <p className='setting-text-normal'>This will permanently delete your account. You will lose your wallet balance, lovrs, posts and messages.</p>
                    <div className='deleteAccountConf'>
                        {deleteConf ? <img src={require('../../assets/icons/checkbox_a.svg')} onClick={toggleDeletion} alt="checked" /> : <img src={require('../../assets/icons/checkbox.svg')} onClick={toggleDeletion} alt="unchecked" />}
                        <p id="walletNormalText" style={{ marginLeft: '10px' }}>I agree and delete my account</p>
                    </div>
                    <div style={{ marginTop: '0px' }} className='setting-pink-button'>
                        <p>DELETE ACCOUNT</p>
                    </div> */}
                        <div className={(isDark) ? 'setting-logout-wrapper-dark' : 'setting-logout-wrapper'}>
                            <img src={require('../../assets/icons/logo.svg')} />
                            <div className='setting-red-button' onClick={handleLogout} >
                                <p>{loggingOut ? "Please Wait" : "LOG OUT"}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div ref={notificationRef} className='settingsRCol'>
                    <div className="setting-left-col-header-desktop">
                        {(!isMobile) ? <Header img='notifications.svg' text="Notification settings" /> : ''}
                    </div>

                    <div className="settings-right-col-content">
                        <div className="notification-section-wrapper">
                            <ToogleButton id="pushEnabler" active={pushNotifications} setActive={setPushNotifications} />
                            <div className='option-wrapper'>
                                <p className='settings-header-red'>Push Notifications</p>
                                <p className='settings-header-text'>Get push notifications to find out what’s going on when you’re not on LOVR</p>
                                <Checkbox text='New Comment' active={pushNewComments} setActive={setPushNewComments} />
                                <Checkbox text='New Likes' active={pushNewLikes} setActive={setPushNewLikes} />
                                <Checkbox text='New Subscriber' active={pushNewSubscribers} setActive={setPushNewSubscribers} />
                                <Checkbox text='New Tip' active={pushNewTip} setActive={setPushNewTip} />
                                <Checkbox text='New Messages' active={pushNewMessage} setActive={setPushNewMessage} />
                            </div>
                        </div>

                        <div className="notification-section-wrapper">
                            <ToogleButton id="emailEnabler" active={emailNotifications} setActive={setEmaiNotifications} />
                            <div className='option-wrapper'>
                                <p className='settings-header-red'>Email Notifications</p>
                                <p className='settings-header-text'>Get emails to find out what’s going on when you’re not on LOVR</p>
                                <Checkbox text='New Comments' active={emailNewComments} setActive={setEmailNewComments} />
                                <Checkbox text='New Likes' active={emailNewLikes} setActive={setEmailNewLikes} />
                                <Checkbox text='New Subscriber' active={emailNewSubscribers} setActive={setEmailNewSubscribers} />
                                <Checkbox text='New Tip' active={emailNewTip} setActive={setEmailNewTip} />
                            </div>
                        </div>

                        <div className="notification-section-wrapper">
                            <ToogleButton id="siteEnabler" active={pushNotifications} setActive={setPushNotifications} />
                            <div className='option-wrapper'>
                                <p className='settings-header-red'>Site Notifications</p>
                                <p className='settings-header-text'>Get site notifications when you're browsing LOVR. Known as Snackbar.</p>
                                <Checkbox text='New Comment' active={pushNewComments} setActive={setPushNewComments} />
                                <Checkbox text='New Likes' active={pushNewLikes} setActive={setPushNewLikes} />
                                <Checkbox text='New Subscriber' active={pushNewSubscribers} setActive={setPushNewSubscribers} />
                                <Checkbox text='New Tip' active={pushNewTip} setActive={setPushNewTip} />
                                <Checkbox text='New Messages' active={pushNewMessage} setActive={setPushNewMessage} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
